import { render, staticRenderFns } from "./ComplieChildMenuForm.vue?vue&type=template&id=6c90b7c0&scoped=true"
import script from "./ComplieChildMenuForm.vue?vue&type=script&lang=js"
export * from "./ComplieChildMenuForm.vue?vue&type=script&lang=js"
import style0 from "./ComplieChildMenuForm.vue?vue&type=style&index=0&id=6c90b7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c90b7c0",
  null
  
)

export default component.exports